import * as React from 'react';
import './planet.scss';

interface IPlanet {
  place: number;
  sport: string;
  src: string;
}

const Planet: React.SFC<IPlanet> = ({ place, sport, src }) => {
  return (
    <div
      className={'c-planet'}
      style={{ marginBottom: 64, transform: 'scale(.8)' }}
    >
      <div className={'c-planet__wrapper'}>
        <div
          className={`planet ${place}`}
          style={{ backgroundImage: `url(${src})` }}
        />
      </div>
      <div className="title">
        <span />
        <p>{sport}</p>
      </div>
    </div>
  );
};

export default Planet;



// WEBPACK FOOTER //
// ./src/containers/universe/components/Planet.tsx